import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, UntypedFormBuilder, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators, UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { InputType } from '../../models/input-type';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DropDownItem } from '../drop-down-item.model';
import { DropDownConstantsFactory } from '../syncfusion/dropdown-constants-factory';
import { AppErrorMessagesComponent } from '../../error-messages/app-error-messages.component';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { YesNoGroupButtonComponent } from '../yes-no-group-button/yes-no-group-button.component';
import { NgClass, NgSwitch, NgSwitchCase } from '@angular/common';

@Component({
    selector: 'app-input-factory',
    templateUrl: './input-factory.component.html',
    styleUrls: ['./input-factory.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputFactoryComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputFactoryComponent),
            multi: true,
        }
    ],
    standalone: true,
    imports: [
        ReactiveFormsModule,
        NgClass,
        NgSwitch,
        NgSwitchCase,
        YesNoGroupButtonComponent,
        DropDownListModule,
        AppErrorMessagesComponent,
    ],
})
export class InputFactoryComponent implements OnInit, OnDestroy, ControlValueAccessor {

  @Input() public inputType: InputType;
  @Input() public control: AbstractControl;
  @Input() public label: string;
  @Input() public dropdownValues: DropDownItem[];
  @Input() public showUntouchedErrors = false;

  public InputType = InputType;
  public dropdownSettings = DropDownConstantsFactory.createEnumDropdownSettings();
  public isRequired = false;

  public form = this.fb.group({
    value: [''],
  });

  public get formControlValue(): UntypedFormControl {
    return this.form.get('value') as UntypedFormControl;
  }

  private unsubscribe$ = new Subject<void>();

  constructor(private fb: UntypedFormBuilder) {
  }

  public ngOnInit(): void {
    this.isRequired = this.control.hasValidator(Validators.required);

    this.form.get('value').valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        this.onChange(value);
        this.onTouched();
      });

    this.control.statusChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.form.get('value').setErrors(this.control.errors);
      if (!!this.control.errors && this.showUntouchedErrors) {
        this.form.get('value').markAsTouched();
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public onChange: any = () => {
  };
  public onTouched: any = () => {
  };

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.get('value').disable();
    } else {
      this.form.get('value').enable();
    }
  }

  public writeValue(obj: any): void {
    this.form.get('value').setValue(obj);
    this.onChange(obj);
    this.onTouched();
  }

  public validate(control: AbstractControl): any {
    return null;
  }
}
